import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Comment } from './Comment';

export class CommentList extends Component {
	render() {
		const { showOpinion = false } = this.props;
		return (
			<div className="act__comments-list">
				{this.props.items.map((item, index) => {
					return (
						<Comment
							{...item}
							key={index}
							canCommentAndSetOpinion={this.props.canCommentAndSetOpinion}
							index={index}
							prefixName={`comment.${index}.`}
							rowId={index + 1}
							addCommentOpinion={(id, type) => this.props.addCommentOpinion(id, type)}
							removeCommentOpinion={(id) => this.props.removeCommentOpinion(id)}
							opinionExecuting={this.props.opinionExecuting}
							agreementAccepted={this.props.agreementAccepted}
							agreementAcceptedRequired={this.props.agreementAcceptedRequired}
							scrollToAgreement={this.props.scrollToAgreement}
							showOpinion={showOpinion}
						/>
					);
				})}
			</div>
		);
	}
}

CommentList.propTypes = {
	canCommentAndSetOpinion: PropTypes.bool,

	items: PropTypes.arrayOf(PropTypes.object),

	addCommentOpinion: PropTypes.func,
	removeCommentOpinion: PropTypes.func
};

CommentList.defaultProps = {
	canCommentAndSetOpinion: false,

	items: [],
	opinionExecuting: [],
	agreementAccepted: false,
	agreementAcceptedRequired: false,
	scrollToAgreement: Function.prototype,
	addCommentOpinion: Function.prototype,
	removeCommentOpinion: Function.prototype
};
